var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"errors"},[_c('img',{attrs:{"src":require("../../assets/images/pug.gif"),"alt":"pug"}}),_c('h1',{staticClass:"u-color u-bfbgcolor u-bgcolor-pseudo"},[_vm._v("Ooops, "),_c('br'),_vm._v("something went "),_c('br'),_vm._v("wrong.")])])
}]

export { render, staticRenderFns }